import { forwardRef } from 'react';
import { LinkProps, Link } from 'react-router-dom';

export interface RouterLinkProps extends LinkProps {
  sx?: {}
};

const RouterLink = forwardRef<HTMLAnchorElement, RouterLinkProps>(({ sx, ...props }: RouterLinkProps, ref) => {
  return (
    <Link
      ref={ref}
      {...props}
      sx={{
        variant: 'styles.a',
        ...sx
      }}
    />
  );
});

export default RouterLink;
